<template>
  <footer>
    <div class="wrapper">
      <!--div class="bottom-img"></div-->
      <div class="nav-bottom">
        <div class="logos">
          <ul>
              <li><a></a></li>
              <li><a></a></li>
              <li><a></a></li>
              <li><a></a></li>
              <li><a></a></li>
              <li><a></a></li>
              <li><a></a></li>
              <li><a></a></li>
              <li><a></a></li>
              <li><a></a></li>
              <li><a></a></li>
              <li><a></a></li>
          </ul>
        </div>
        <div class="copy">Copyright © <span class="highlight">MEGA</span>. All Rights Reserved.</div>

        <!-- <div class="top">
          <div class="footer-list">
            <h4>CASINO</h4>
            <ul>
              <template v-for="item in commonCodeByOrder['casino']" v-bind:key="item.vendorKey">
                <li
                    v-if="item.groupCodeName.indexOf('H-') === -1"
                    @click="onCasinoSelectGame(item.groupCode, item.code)"
                >
                {{$i18n.locale !== 'ko' ? item[`codeName${$i18n.locale.toUpperCase()}`] : item.codeName}}
                </li>
              </template>
            </ul>
          </div>
          <div class="footer-list">
            <h4>SLOT</h4>
            <ul>
              <template v-for="item in commonCodeByOrder['slot']" v-bind:key="item.vendorKey">
                <li
                    v-if="item.groupCodeName.indexOf('H-') === -1"
                    @click="slotOpen('isSlot', 'slot', item.codeName, item.code)"
                >
                {{$i18n.locale !== 'ko' ? item[`codeName${$i18n.locale.toUpperCase()}`] : item.codeName}}
                </li>
              </template>
            </ul>
          </div>
        </div> -->
      </div>
    </div>

  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState([
      'siteOption',
      'commonCodeByOrder'
    ])
  }
}
</script>
<style scoped src="@/styles/footer.css"></style>
<style scoped src="@/styles/common.css"></style>
<style scoped>
.footerInfo ul li{cursor: pointer;}
.logos {
    padding: 20px 0;
    border-top: 1px solid #2d3748;
    border-bottom: 1px solid #2d3748;
}

.logos ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 10px;
    list-style: none;
    padding: 0;
    margin: 0;
}
.logos ul li {
    display: block;
    float: left;
    width: 150px;
    text-align: center;
}

.logos ul li:nth-child(29) {
    width: 14.28%
}

.logos ul li:nth-child(30) {
    width: 14.28%
}

.logos ul li:nth-child(31) {
    width: 14.28%
}

.logos ul li:nth-child(32) {
    width: 14.28%
}

.logos ul li:nth-child(33) {
    width: 14.28%
}

.logos ul li:nth-child(34) {
    width: 14.28%
}

.logos ul li a {
    display: block;
    width: 110px;
    height: 40px;
    margin: 10px auto;
    background-image: url(../assets/img/footer_logos.png);
    background-repeat: no-repeat;
    -webkit-transition: all .3s ease-out;
    transition: all .3s ease-out;
}

.logos ul li:nth-child(1) a {
    background-position: 0 -160px
}

.logos ul li:nth-child(2) a {
    background-position: -110px -160px
}

.logos ul li:nth-child(3) a {
    background-position: -440px -160px
}

.logos ul li:nth-child(4) a {
    background-position: -660px -160px
}

.logos ul li:nth-child(5) a {
    background-position: -770px -160px
}

.logos ul li:nth-child(6) a {
    background-position: -880px -160px
}

.logos ul li:nth-child(7) a {
    background-position: -990px -160px
}

.logos ul li:nth-child(8) a {
    background-position: -220px -200px
}

.logos ul li:nth-child(9) a {
    background-position: -440px -200px
}

.logos ul li:nth-child(10) a {
    background-position: -770px -200px
}

.logos ul li:nth-child(11) a {
    background-position: 0 -280px
}

.logos ul li:nth-child(12) a {
    background-position: -110px -280px
}

.logos ul li:nth-child(1) a:hover {
    background-position: 0 0
}

.logos ul li:nth-child(2) a:hover {
    background-position: -110px 0
}

.logos ul li:nth-child(3) a:hover {
    background-position: -440px 0
}

.logos ul li:nth-child(4) a:hover {
    background-position: -660px 0
}

.logos ul li:nth-child(5) a:hover {
    background-position: -770px 0
}

.logos ul li:nth-child(6) a:hover {
    background-position: -880px 0
}

.logos ul li:nth-child(7) a:hover {
    background-position: -990px 0
}

.logos ul li:nth-child(8) a:hover {
    background-position: -220px -40px
}

.logos ul li:nth-child(9) a:hover {
    background-position: -440px -40px
}

.logos ul li:nth-child(10) a:hover {
    background-position: -770px -40px
}

.logos ul li:nth-child(11) a:hover {
    background-position: 0 -120px
}

.logos ul li:nth-child(12) a:hover {
    background-position: -110px -120px
}

.logos li a {
    display: block;
    width: 100%;
    height: 100%;
}
.copy {
    text-align: center;
    color: #a0aec0;
    font-size: 12px;
    padding: 20px 0;
}
.copy .highlight {
    color: #00a9ff;
    font-weight: bold;
}
</style>
